<ion-app>
  <app-unlock *ngIf="this.isLocked"></app-unlock>
  <itl-maintenance-snack-bar *ngIf="!this.isLocked">
    <itl-split-pane></itl-split-pane>
  </itl-maintenance-snack-bar>
</ion-app>
